/* eslint-disable react/react-in-jsx-scope */
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { toast } from "@/components/ui/use-toast";
import usePostData from "@/hooks/usePostData";
import { cn } from "@/libs/utils";
import { usePreviewPerformance } from "@/store/store";
import { FC, useEffect, useState } from "react";
import Chart from "./Chart";

const ChartItem: FC<{
  project;
  indicator;
  className?: string;
  currentYear: number;
}> = ({ project, indicator, className, currentYear }) => {
  const [size, setSize] = useState("w-1/2");
  const indicatorCumulativeValue = Boolean(
    (indicator as any)?.cumulativeReporting ?? (indicator as any)?.cumulative
  );
  const [isCumulative, setIsCumulative] = useState(
    indicatorCumulativeValue
  );
  const { previews, setPreviews } = usePreviewPerformance();
  const { postData } = usePostData<any>();

  useEffect(() => {
    setTimeout(() => {
      if (/^tco2_sequestrees/.test(indicator.code)) {
        setPreviews({ name: indicator.name, value: "3" });
      } else {
        setPreviews({ name: indicator.name, value: "1" });
      }
    }, 1000);
  }, []);

  useEffect(() => {
    setIsCumulative(indicatorCumulativeValue);
  }, [indicatorCumulativeValue]);

  const handleChangeCumulative = async (value: string) => {
    const nextValue = value === "1";
    const previousValue = isCumulative;

    setIsCumulative(nextValue);

    const response = await postData({
      url: `${import.meta.env.VITE_API_ENDPOINT}/parameter/save/cumul`,
      data: {
        currentItem: {
          id: indicator.id,
        },
        cumulativeReporting: nextValue,
      },
    });

    if (!response) {
      setIsCumulative(previousValue);
      toast({
        className: "text-red-500",
        title: "Une erreur est survenue lors de la sauvegarde.",
      });
      return;
    }

    toast({
      title: "Paramètre sauvegardé",
      description: "Le mode de cumul a bien été mis à jour.",
    });
  };

  return (
    <div className={cn(`mb-4 ${size}`, className)}>
      <div className="group relative rounded-[20px] bg-[#F7F9FB] p-4 pl-0">
        <h3 className="mb-4 ml-8 font-semibold text-[#626262]">
          {indicator.name}
        </h3>
        <Chart
          project={project}
          indicator={indicator}
          currentYear={currentYear}
          isCumulative={isCumulative}
        />
        <Indice />

        {indicator.code !== "tco2_sequestrees" &&
          !indicator.code.includes("tco2_sequestrees-") &&
          indicator.correspondance == null && (
            <div className="absolute right-4 top-4 flex items-center gap-2">
              Cumul :
              <Select
                value={isCumulative ? "1" : "0"}
                onValueChange={handleChangeCumulative}
              >
                <SelectTrigger className="text-foreground/90 outline-none focus:ring-0 focus:ring-transparent w-36">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="1">Cumulatif</SelectItem>
                    <SelectItem value="0">Non cumulatif</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
              Affichage :{" "}
              <Select
                onValueChange={(e) =>
                  setPreviews({ name: indicator.name, value: e })
                }
              >
                <SelectTrigger className="text-foreground/90 outline-none focus:ring-0 focus:ring-transparent  w-28">
                  <SelectValue
                    placeholder={
                      previews[indicator.name] == "1"
                        ? "Mois"
                        : previews[indicator.name] == "2"
                        ? "Trimestre"
                        : "Année"
                    }
                  />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="1">Mois</SelectItem>
                    <SelectItem value="2">Trimestre</SelectItem>
                    <SelectItem value="3">Année</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          )}
      </div>
    </div>
  );
};

const Indice = () => {
  return (
    <div className="ml-10 mt-5 flex items-center gap-3">
      <div className="flex items-center gap-1">
        <div className={`size-2 rounded-full bg-[#59ADC4]`}></div>
        Prévu
      </div>
      <div className="flex items-center gap-1">
        <div className={`size-2 rounded-full bg-[#A7FFD0]`}></div>
        Réalisé
      </div>
      <div className="flex items-center gap-1">
        <div className={`size-2 rounded-full bg-[#CFE7FF]`}></div>
        Verifié / justifié / certifié
      </div>
    </div>
  );
};
export default ChartItem;
